<div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="mat-accent m-0">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title" *ngIf="!usedDiscounts">
                {{'Active discounts'|translate}}
            </span>
            <span class="title dialog-title" *ngIf="usedDiscounts">
                {{'Used discounts'|translate}}
            </span>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="p-24 pb-0 m-0" fusePerfectScrollbar>
        <div class="invoice tab-content" fusePerfectScrollbar>

            <div id="invoice" class="compact page-layout blank" fxLayout="row" fusePerfectScrollbar>

                <div class="invoice-container">

                    <!-- INVOICE -->
                    <div class="card">
                        <span *ngIf="loading">{{'Loading data'|translate}}</span>
                        <span *ngIf="!loading && discounts.total===0">{{'Active discounts not found.'|translate}}</span>
                        <table class="simple invoice-table" *ngIf="!loading && discounts.total>0">
                            <thead>
                            <tr>
                                <th>{{'Name'|translate}}</th>
                                <th class="text-left">{{'Value'|translate}}</th>
                                <th class="text-left">{{'Products/Vouchers/Lines'|translate}}</th>
                                <th class="text-left">{{'Can connect'|translate}}</th>
                                <th class="text-left">{{'Available only first time'|translate}}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let item of discounts.items">
                                <td>
                                    <div class="title">
                                        {{item.name}}
                                    </div>
                                </td>
                                <td class="text-right">
                                    {{item.value}}<span *ngIf="item.type==='percent'">%</span><span *ngIf="item.type==='value'">PLN</span>
                                </td>
                                <td class="text-center">
                                    <span *ngIf="item.minimalQuantityOfProducts">{{item.minimalQuantityOfProducts}}</span>
                                    <span *ngIf="!item.minimalQuantityOfProducts">-</span>
                                    <span>/</span>
                                    <span *ngIf="item.minimalQuantityOfVouchers">{{item.minimalQuantityOfVouchers}}</span>
                                    <span *ngIf="!item.minimalQuantityOfVouchers">-</span>
                                    <span>/</span>
                                    <span *ngIf="item.minimalQuantityOfLines">{{item.minimalQuantityOfLines}}</span>
                                    <span *ngIf="!item.minimalQuantityOfLines">-</span>
                                </td>
                                <td class="text-center">
                                    {{item.canConnect.toString()|translate}}
                                </td>
                                <td class="text-center">
                                    {{item.availableOneTimeFirstDay.toString()|translate}}
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="end center">

        <button
                mat-button
                class="mr-8"
                (click)="matDialogRef.close()"
                aria-label="Close">
            {{'Close'|translate}}
        </button>

    </div>
</div>
